module.exports = __webpack_public_path__ + "img/status-icn_cancel_completed@3x.2af4919d.png";